import AccountStatisticalBlock from './AccountStatisticalBlock';

export default AccountStatisticalBlock;
